module.exports = __webpack_public_path__ + "media/images/default/pages/public_science_2/4-c122ad6de3e6a466189317e84a8c7bf8.jpg";